import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';

import {
  GET_NOTIFICATIONS_HISTORIC,
  SET_NOTIFICATIONS_HISTORIC_PAGINATION,
  SET_NOTIFICATIONS_HISTORIC_FILTERS,
  RESET_NOTIFICATIONS_HISTORIC,
  TOGGLE_NOTIFICATION_HISTORIC,
} from 'notifications_historic/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const notificationHistoric = new schema.Entity('notification_historic');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['name', 'subject', 'description'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { notification_historic: {} },
  result: { notification_historic: [] },
};

export const getPending = (state) => ({ ...state, isLoading: true, needFetch: false });

export const getFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  pagination: {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  },
  ...normalize(
    { notification_historic: payload.records },
    { notification_historic: [notificationHistoric] }
  ),
});

export const getRejected = (state) => ({ ...state, isLoading: false });

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const togglePending = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    notification_historic: {
      ...state.entities.notification_historic,
      [meta.id]: { ...state.entities.notification_historic[meta.id], isLoading: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    notification_historic: {
      ...state.entities.notification_historic,
      [meta.id]: { ...state.entities.notification_historic[meta.id], isLoading: false },
    },
  },
});

export const toggleFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    notification_historic: {
      ...state.entities.notification_historic,
      [payload.notification_historic.id]: { ...payload.notification_historic, isLoading: false },
    },
  },
});

const reducers = {
  [GET_NOTIFICATIONS_HISTORIC]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_NOTIFICATIONS_HISTORIC_PAGINATION]: setPagination,
  [SET_NOTIFICATIONS_HISTORIC_FILTERS]: setFilters,
  [RESET_NOTIFICATIONS_HISTORIC]: reset,
  [TOGGLE_NOTIFICATION_HISTORIC]: {
    [PENDING]: togglePending,
    [FULFILLED]: toggleFulfilled,
    [REJECTED]: toggleRejected,
  },
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/reducers/notifications_historic_list_reducers.js